import React from 'react';

import { CustomModal, PrimaryButton } from 'components/molecules';
import { ErrorCircleIcon, SuccessCircleIcon } from 'assets/icons';
import { Typography } from '@mui/material';

interface Props {
  open: boolean;
  onClose: () => void;
  type: string;
  message: string;
  btnText: string;
  onSubmit: () => void;
}

const AlertModal = ({
  open, onClose, onSubmit, type = 'succss', message = '', btnText = 'OK',
}: Props) => (
  <CustomModal open={open} onClose={onClose}>
    <div className="d-flex flex-column justify-content-center align-items-center">
      <div className="mb-2">
        {type === 'success' && <SuccessCircleIcon sx={{ width: '60px', height: '60px' }} />}
        {type === 'error' && <ErrorCircleIcon sx={{ width: '60px', height: '60px' }} />}
      </div>
      <Typography variant="h5" sx={{ mb: 3 }}>{message}</Typography>
      <PrimaryButton onClick={onSubmit}>{btnText}</PrimaryButton>
    </div>
  </CustomModal>
);

export default AlertModal;
